import React, { useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import ButtonMain from '../../../../Atoms/ButtonMain';
import ButtonSecondary from '../../../../Atoms/ButtonSecondary';
import IdeaReviewCard from '../../../BrainstormIdeas/Molecules/IdeaReviewCard';
import './styles.css';

export default function KnowledgeBaseModal({ 
    show, 
    onHide, 
    outputId,
    onToggleKnowledgeBase,
    handleConclude,
    loading,
    brainstormData
}) {
    const handleCancel = () => {
        onHide();
    };

    const guidingQuestions = useMemo(() => {
        if (!brainstormData) return [];

        const selectedChallenge = brainstormData.challenges?.find(
            challenge => challenge.selected === true
        );

        if (!selectedChallenge) return [];

        const guidingQuestionsArr = Object.values(brainstormData.guiding_questions || {});
        
        return guidingQuestionsArr.filter(
            question => 
                question.challenge_id === selectedChallenge.id && 
                question.selected === true
        );
    }, [brainstormData]);

    return (
        <Modal 
            show={show} 
            onHide={handleCancel}
            centered
            backdrop="static"
            className="knowledge-base-modal"
            size="lg"
        >
            <Modal.Header closeButton className="knowledge-base-modal-header">
                <Modal.Title>Itens selecionados para a Base de conhecimento</Modal.Title>
            </Modal.Header>
            
            <Modal.Body className="knowledge-base-modal-body">
                <div className="guiding-questions-list">
                    {guidingQuestions.length === 0 ? (
                        <p className="text-center text-muted">Nenhuma questão norteadora encontrada.</p>
                    ) : (
                        guidingQuestions.map((question) => {
                            const ideas = question.ideas || [];
                            const selectedIdeasCount = ideas.filter(idea => idea.selected === true).length;
                            
                            return (
                                <IdeaReviewCard
                                    key={question.id}
                                    guidingQuestion={question}
                                    selectedIdeasCount={selectedIdeasCount}
                                    isInKnowledgeBase={question.in_knowledge_base || false}
                                    onToggle={() => onToggleKnowledgeBase(outputId, question.id)}
                                />
                            );
                        })
                    )}
                </div>
            </Modal.Body>
            
            <Modal.Footer className="knowledge-base-modal-footer">
                <ButtonSecondary onClick={handleCancel} disabled={loading}>
                    Cancelar
                </ButtonSecondary>
                
                <ButtonMain
                    onClick={() => handleConclude(brainstormData)}
                    disabled={loading}
                >
                    {loading ? 'Concluindo...' : 'Concluir'}
                </ButtonMain>
            </Modal.Footer>
        </Modal>
    );
}
